export const DEFAULT_INTERVENANT_CODE = '4';
export const DEFAULT_INTERVENANT_EXPERT_CODE = '7';
export const DEFAULT_LAWYER_CODE_NAME = 'Avocat_Reserve';
export const DEFAULT_PROVIDER_CODE = '104';
export const PROFIL_OPENNER_GPO = 'GPO';
export const PROFIL_OPENNER_GJ = 'GJ';
export const PROFIL_OPENNER_LAWYER = 'LAWYER';
export const PROFIL_OPENNER_GO = 'GO';
export const PROFIL_OPENNER_GSJ = 'GSJ';
export const HOLDER_PV_PROVIDER = 1;
export const HOLDER_PV_LAWYER = 2;
export const HOLDER_PV_OTHER = 3;
